import * as React from "react";
import { cn } from "../utils/cn";
import { Text, Mono, Heading } from "../primitives/typography";
import { Activity } from "lucide-react";

export interface ActivityItem {
    id: string;
    timestamp: string;
    name: string;
    action: string;
}

export interface RecentActivityCardProps extends React.HTMLAttributes<HTMLDivElement> {
    items: ActivityItem[];
}

const RecentActivityCard = React.forwardRef<HTMLDivElement, RecentActivityCardProps>(
    ({ className, items, ...props }, ref) => (
        <div ref={ref} className={cn("border-border bg-card flex flex-col rounded-2xl border", className)} {...props}>
            {/* Header */}
            <div className="px-5 pt-5 pb-4">
                <div className="flex items-center gap-2">
                    <Activity className="text-warning h-4 w-4 shrink-0" />
                    <Heading level={6} className="font-semibold">
                        Recent activity
                    </Heading>
                </div>
                <Text size="sm" muted>
                    Orgs with notable activity
                </Text>
            </div>

            {/* Activity rows */}
            <div className="divide-border flex flex-col divide-y">
                {items.map((item) => (
                    <div key={item.id} className="flex items-start gap-4 px-5 py-3">
                        <Mono size="xs" muted className="w-16 shrink-0 pt-0.5">
                            {item.timestamp}
                        </Mono>
                        <Text size="sm" muted className="min-w-0 flex-1">
                            <Text as="span" size="sm" weight="semibold" className="text-foreground">
                                {item.name}
                            </Text>{" "}
                            {item.action}
                        </Text>
                    </div>
                ))}
            </div>
        </div>
    ),
);
RecentActivityCard.displayName = "RecentActivityCard";

export { RecentActivityCard };
